module.exports = __webpack_public_path__ + "fonts/font.61dd7553.woff";